import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  Container,
  CardStyled,
  OptionStyled,
  BtnStyled
} from './styles'

const Dropdown = ({
  options = [],
  renderBtn: BtnCustom,
  renderCard: CardCustom,
  renderOption: OptionCustom,
  isShutDown
}) => {

  const [isOpen, setIsOpen] = useState()

  const [btnPosition, setBtnPosition] = useState({})
  const [cardWidth, setCardWidth] = useState(0)

  const btnRef = useRef()
  const cardRef = useRef()
  
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const Btn = BtnCustom || BtnStyled
  const Card = CardCustom || CardStyled
  const Option = OptionCustom || OptionStyled

  /**
   * Close the card when user does a click
   */
  useEffect(() => {
    const closeDrop = () => {
      handleClose()
      window.removeEventListener('click', closeDrop)
      window.removeEventListener('resize', closeDrop)
    }
    
    if (isOpen) {
      window.addEventListener('click', closeDrop)
      window.addEventListener('resize', closeDrop)
    }

    return () => {
      window.removeEventListener('click', closeDrop)
      window.addEventListener('resize', closeDrop)
    }
  }, [isOpen])

  /**
   * Card follow btn position
   */
  useEffect(() => {
    if (!isOpen || !btnRef.current) return

    const getBtnPosition = () => {
      if (!btnRef.current) return

      const {
        left,
        bottom,
        width
      } = btnRef.current.getBoundingClientRect()

      setBtnPosition({
        left: left + width / 2, // center card in middle of btn
        bottom: bottom + 10 // push card 10px away from btn
      })
    }
    
    getBtnPosition()
    window.addEventListener('resize', getBtnPosition)
    window.addEventListener('scroll', getBtnPosition)

    return () => {
      window.removeEventListener('resize', getBtnPosition)
      window.removeEventListener('scroll', getBtnPosition)
    }
  }, [isOpen])

  /**
   * Get and set card width (offset)
   * and show it
   */
  useEffect(() => {
    if (!isOpen) return
    
    const { width } = cardRef.current.getBoundingClientRect()
    setCardWidth(width)
  }, [isOpen])

  /**
   * This is necessary to avoid a ghost flash
   * when the previous position is saved and
   * user open the same card in other position
   */
  useEffect(() => {
    if (isOpen && cardWidth) {
      cardRef.current.style.opacity = 1
      return
    }

    cardRef.current.style.opacity = 0
  }, [isOpen, cardWidth])

  useEffect(() => {
    if (isOpen && isShutDown) {
      handleClose()
    }
  }, [isShutDown, isOpen])


  return (
    <Container onClick={handleOpen}>
      <Btn $isOpen={isOpen} ref={btnRef} />
      <Card
        ref={cardRef}
        $isOpen={isOpen}
        $xPosition={btnPosition.left - cardWidth }
        $yPosition={btnPosition.bottom}
      >
        {options.map(opt => (
          <Option
            key={opt.label}
            onClick={opt.onClick}
            to={opt.to}
            as={opt.to ? Link : 'button'}
          >
            {opt.label}
          </Option>
        ))}
      </Card>
    </Container>
  )
}

export default Dropdown